<template>
  <div>
    <div id="overlay" v-if="fetchingData">
      <div class="spinner"></div>
    </div>

    <h3>Checkout</h3>

    <table class="table">
      <thead>
        <tr>
          <th scope="col">Description</th>
          <th scope="col">Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in cart.items" v-bind:key="item.id">
          <td>{{item.description}}</td>
          <td>${{item.amount}}</td>
        </tr>
        <tr>
          <td>Total:</td>
          <td>${{totalPrice}}</td>
        </tr>
      </tbody>
    </table>
    <p>
      <small>
        All fees are non-refundable.
      </small>
    </p>
    <div class="row" v-if="totalPrice > 0">
      <div class="col">
        <button class="btn btn-primary btn-lg text-center" @click="payByCreditCard">Pay with Credit Card</button>
      </div>
      <div class="col">
        <div class="alert alert-primary">
            If your financial institution requires a Company ID, the NEW Company/Provider ID is 0000408976.
            <i>(The current COMPANY ID may still be used until the change takes place)</i>
        </div>
        <button class="btn btn-primary btn-lg" @click="payByAch">Pay with ACH</button>
      </div>
    </div>

    <div v-else>
      <p>
        Finalize and submit the transaction:
      </p>
      <button class="btn btn-primary" @click="finalize">
        Submit Transaction
      </button>
    </div>
    <form ref="lexisNexisForm" method="post" :action="lnLexisNexisPostUrl">
      <input type="hidden" name="ORDER_XML" v-model="orderXml" />
    </form>
  </div>
</template>

<script>
import { getPermitCart, errorNotification, finalizeCart } from '~/js/FormFunctions';
import { ShoppingCart } from '~/js/FormObjects';

const sumReducer = (accumulator, currentValue) => accumulator + currentValue;

export default {
  name: 'Checkout',
  data() {
    return {
      cart: new ShoppingCart(),
      fetchingData: false,
      permitId: null,
      revisionId: null,
      contractorRegId: null,
      orderXml: null,
      sessionId: null,
      lnReturnUrl: `${window.location.protocol}//${window.location.hostname}`
          + `${window.location.port ? `:${window.location.port}` : ''}/DesWebPortal/api/checkout/lnConfirm/`,
      // lnReturnUrl: 'http://localhost:8081/#/thankYou/'
      lnLexisNexisPostUrl: null,
    };
  },
  mounted() {
    const self = this;
    const { revisionId } = this.$route.query;
    if (revisionId) {
      // console.log('get the revision: ', revisionId)
    }
    this.permitId = this.$route.query.permitId;
    this.contractorRegId = this.$route.query.contractorRegId;
    this.revisionId = this.$route.query.revisionId;
    this.sessionId = this.$route.query.sessionId;

    const params = {
      applicationNumber: this.permitId,
      contractorRegId: this.contractorRegId,
      revisionId: this.revisionId,
    };
    this.fetchingData = true;
    getPermitCart(params)
      .then((data) => {
        self.fetchingData = false;
        self.cart = data;
        self.lnLexisNexisPostUrl = `https://${data.lexisNexisPaymentBaseUrl}/oobML/il/co/cook/DES/`;
      })
      .catch(() => {
        self.fetchingData = false;
        if (self.permitId) {
          // sloppily assuming demolition since this should only happen if a demo application doesn't have any file
          // attachments
          self.$router.push({ name: 'PermitApplication', params: { projectType: 'demolition' }, query: { applicationNumber: this.permitId } });
        }
      });
  },
  methods: {
    payByCreditCard() {
      const self = this;
      this.fetchingData = true;
      const params = {
        applicationNumber: this.permitId,
        contractorRegId: this.contractorRegId,
        revisionId: this.revisionId,
      };
      getPermitCart(params, true)
        .then((data) => {
          const total = data.items
            .map(i => i.amount)
            .reduce(sumReducer);

          const orderXml = `<?xml version="1.0" encoding="utf-8"?>
            <multiLineFormPostRequest>
            <bypassReceiptUrl>${this.lnReturnUrl + data.id}</bypassReceiptUrl>
            <lexisNexisCode>71527</lexisNexisCode>
            <paymentLineItems>
            <productLines>
            <productAmount>${total}</productAmount>
            <lexisNexisProductCode>DES Online Payment</lexisNexisProductCode>
            <refField>${data.id}</refField>
            <refField1>${data.sessionId}</refField1>
            </productLines>
            </paymentLineItems>
            </multiLineFormPostRequest>`;
          self.$set(self, 'orderXml', orderXml);

          self.$nextTick(() => {
            self.$refs.lexisNexisForm.submit();
          });
        })
        .catch((error) => {
          self.fetchingData = false;
          console.error(error);
        });
    },
    payByAch() {
      this.fetchingData = true;
      const self = this;
      this.$http.post('api/checkout/paymentus', {
        applicationNumber: this.permitId,
        contractorRegistrationId: this.contractorRegId,
        revisionId: this.revisionId,
      })
        .then((response) => {
          window.location = response.data.url;
        })
        .catch((error) => {
          self.fetchingData = false;
          errorNotification('Error submitting payment to vendor:', error);
        });
    },
    finalize() {
      this.fetchingData = true;
      const self = this;

      const params = {
        applicationNumber: this.permitId,
        contractorRegId: this.contractorRegId,
        revisionId: this.revisionId,
        saveCart: true,
      };
      getPermitCart(params, true)
        .then((response) => {
          finalizeCart(response.id)
            .then(() => {
              self.fetchingData = false;
              self.$store.commit('temporaryForm', response);
              self.$router.push({ name: 'GenericThanks' });
            })
            .catch(() => {
              self.fetchingData = false;
            });
        })
        .catch(() => {
          self.fetchingData = false;
        });
    },
  },
  computed: {
    totalPrice() {
      if (this.cart.items.length === 0) {
        return 0;
      }
      return this.cart.items
        .map(i => i.amount)
        .reduce(sumReducer);
    },
  },
};
</script>
